<template>
  <vs-dropdown vs-trigger-click class="cursor-pointer">
    <small class="flex cursor-pointer">
      <span>{{ `Tahun ${value}` }}</span>
      <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" class="ml-1" />
    </small>
    <vs-dropdown-menu class="w-32">
      <vs-dropdown-item
        v-for="(item, index) in years"
        :key="index"
        @click="setYear(item)"
      >
        Tahun {{ item }}
      </vs-dropdown-item>
    </vs-dropdown-menu>
  </vs-dropdown>
</template>

<script>
export default {
  props: {
    value: {
      required: false
    },
    years: {
      required: false,
      type: Array,
      default: function(){
        return [2018, 2019, 2020, 2021];
      }
    }
  },
  data () {
    return {
      items: []
    }
  },
  methods: {
    setYear(year) {
      this.$emit('input', year)
    }
  }
}
</script>